const localPermissions = {
  Entryform: {
    update: ['updateEntryForm'],
    create: ['createEntryForm'],
    changeStatus: ['changeStatusEntryForm'],
    approve: ['approveEntryForm', 'changeStatusEntryForm'],
    return: ['returnEntryForm', 'changeStatusEntryForm'],
    history: ['getHistoryForm'],
    copy: ['copyEntryForm'],
    exportExcel: ['exportExcelEntryPasses'],
    balanceAdjustment: ['createEntryFormCorrected'],
    notifyToAuthorize: ['saveReviewAprovedEntryFormToAuthorize'],
    createPass: ['createEntryPass'],
    // Caso 1047: editar Peso Bruto, Peso Neto y Número de Bultos de un item
    // en estado APROBADO. Exclusivo de los roles operador/operador_2.
    editApprovedWeights: ['editApprovedWeightsEntryForm']
  },
  Outputform: {
    update: ['updateOutputForm'],
    create: ['createOutputForm'],
    changeStatus: ['changeStatusOutputForm'],
    copy: ['copyOutputForm'],
    balanceAdjustment: ['createOutputFormCorrected'],
    createPass: ['createDispatchPass']
  },
  EntryPass: {
    update: ['updateEntryPass'],
    create: ['createEntryPass'],
    changeStatus: ['changeStatusEntryPass']
  },
  OutputPass: {
    update: ['updateDispatchPass'],
    create: ['createDispatchPass'],
    changeStatus: ['changeStatusDispatchPass']
  },
  ProductOrder: {
    update: ['updateProductOrder'],
    create: ['createProductOrder'],
    changeStatus: ['changeStatusProductOrder']
  }
}

export { localPermissions }
